import {
  CACHE_DURATION,
  USER_CACHE_KEY,
  USER_CACHE_TIMESTAMP_KEY,
} from "./constants";

// Safe localStorage operations with error handling
export const userStorage = {
  get: <T>(key: string): T | null => {
    if (typeof window === "undefined") return null;

    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.warn(`Failed to parse localStorage item: ${key}`, error);
      return null;
    }
  },

  set: (key: string, value: unknown): void => {
    if (typeof window === "undefined") return;

    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn(`Failed to save to localStorage: ${key}`, error);
    }
  },

  remove: (key: string): void => {
    if (typeof window === "undefined") return;

    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(`Failed to remove from localStorage: ${key}`, error);
    }
  },

  clear: (): void => {
    if (typeof window === "undefined") return;

    try {
      localStorage.removeItem(USER_CACHE_KEY);
      localStorage.removeItem(USER_CACHE_TIMESTAMP_KEY);
    } catch (error) {
      console.warn("Failed to clear user cache:", error);
    }
  },
};

export const isCacheValid = (): boolean => {
  const timestamp = userStorage.get<number>(USER_CACHE_TIMESTAMP_KEY);
  if (!timestamp) return false;

  const now = Date.now();
  return now - timestamp < CACHE_DURATION;
};

export const getUserFromCache = () => {
  return userStorage.get<any>(USER_CACHE_KEY);
};

export const saveUserToCache = (user: unknown): void => {
  userStorage.set(USER_CACHE_KEY, user);
  userStorage.set(USER_CACHE_TIMESTAMP_KEY, Date.now());
};
